import { clone } from 'ramda';
import { CASE_CATEGORIES, CASE_STATUS } from '../cases/list/case.constants';
export function transformCaseForService(editMode, editCase, categoryDetails) {
  var clonedCase = clone(editCase);
  if (editCase.Category === CASE_CATEGORIES.TROUBLE_CALL || editCase.CaseTemplateId === CASE_CATEGORIES.TROUBLE_CALL || editCase.Category === CASE_CATEGORIES.INVOICE_DISPUTE || editCase.CaseTemplateId === CASE_CATEGORIES.INVOICE_DISPUTE) {
    clonedCase.Details = getCaseDetails(editMode, clonedCase, categoryDetails);
  }
  return clonedCase;
}
export function shouldHaveResolutionText() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    Status = _ref.Status;
  return Status === CASE_STATUS.CLOSED || Status === CASE_STATUS.CANCELED;
}
function getCaseDetails(editMode, editCase) {
  var categoryDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var details = {};
  if (editCase.Category === CASE_CATEGORIES.TROUBLE_CALL || editCase.CaseTemplateId === CASE_CATEGORIES.TROUBLE_CALL) {
    details.TroubleCallDetails = categoryDetails;
  } else if (editCase.Category === CASE_CATEGORIES.INVOICE_DISPUTE || editCase.CaseTemplateId === CASE_CATEGORIES.INVOICE_DISPUTE) {
    details.InvoiceDisputeDetails = editCase.Details.InvoiceDisputeDetails || {};
    details.InvoiceDisputeDetails.ApprovedAmount = details.InvoiceDisputeDetails.ApprovedAmount || 0;
  }
  return details;
}